import dataSecurityServer from "./datensicherheit-bei-der-grundriss-schmiede.jpg";

export { dataSecurityServer };
